<template>
  <div class="task-number-card">
    <div class="task-number-card_title-wrap">
      <p class="title">
        {{ title }}
      </p>
      <p class="number">
        {{ totalNumber }}
      </p>
    </div>
    <div class="task-number-card_content">
      <div
        v-for="(system_e,system_k) in systemType"
        :key="system_k"
        class="content-list"
      >
        <div
          v-if="system_e.icon"
          class="leading-icon"
        >
          <i :class="system_e.icon" />
        </div>
        <div
          v-if="system_e.image"
          class="leading-image"
        >
          <img
            :src="system_e.image"
            alt=""
          >
        </div>
        <p class="content-text">
          {{ system_e.systemTitle }}
        </p>
        <p class="content-text number">
          {{ system_e.number }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TaskNumberCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    totalNumber: {
      type: Number,
      default: 0,
    },
    systemType: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/task-number-card";
</style>